// consts
import { commonImage } from 'constants/images';

// libraries
import { Button } from '@mui/material';
import styled from 'styled-components';

export const StyledTextButton = styled(Button)`
  &.MuiButtonBase-root {
    /* width: 100%; */
    height: 37px;
    box-shadow: none;
    border-radius: 6px;
    /* box-shadow: 0px 4px 19px 0px rgba(0, 0, 0, 0.1); */
    text-transform: capitalize !important;

    &:hover {
      box-shadow: 0px 4px 19px 0px #0000001a;
    }

    &.MuiButton-text {
      color: var(--color-charcoal-black);
    }

    &.MuiButton-contained {
      background-color: var(--color-primary-blue);
      color: var(--color-white);

      &.MuiButton-contained {
        background-color: var(--color-primary-blue);
      }
    }

    &.MuiButton-outlined {
      border: 1px solid var(--color-primary-blue);
      background-color: var(--color-white);
      color: var(--color-primary-blue);

      &.MuiButton-outlined {
        background-color: var(--color-white);
      }
    }

    &.close {
      background-image: url(${commonImage.modalClose});
      background-size: contain;
      background-repeat: no-repeat;
      transform: translateY(8px);
      margin-left: auto;
      width: 24px !important;
      border: none !important;
      box-shadow: none !important;
      min-width: 24px !important;
    }

    &.iconButton {
      padding: 0;
      width: 24px !important;
      min-width: 24px !important;
      border: none !important;
      box-shadow: none !important;
    }

    &.close-btn {
      display: inline-flex;
      align-items: flex-start;
      padding: 8px 16px;
      gap: 10px;
      border-radius: 6px;
      border: 1px solid var(--color-pale-gray);
      background: var(--color-off-white) !important;
      color: var(--color-text-gray);
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: normal;
      box-shadow: none !important;

      &.Mui-disabled {
        box-shadow: none !important;
        border-radius: 6px;
        border: 1px solid #dadada;
        background: #f8f8f8;
      }
    }
  }
`;
